import React, { useCallback } from 'react';
import UIModal from 'Components/UIComponents/UIModal';
import useIsMobile from 'Hooks/Common/useIsMobile';
import classNames from 'classnames';
import Calendar from 'Components/UIComponents/UIDatePicker/components/DayPicker';
import { TEAMMEMBER_FREEZE_MAX_DAYS } from 'Utils/constants';

interface FreezeTeammateModalProps {
  onClose: () => void;
  onFreezeTeammate: (freezeUntil: string) => void;
}

const FreezeTeammateModal = ({ onClose, onFreezeTeammate }: FreezeTeammateModalProps) => {
  const isMobile = useIsMobile();

  const toMonth = new Date(Date.now() + TEAMMEMBER_FREEZE_MAX_DAYS * 24 * 60 * 60 * 1000);

  const handleSubmit = useCallback(
    async value => {
      onFreezeTeammate(value);
      onClose();
    },
    [onClose, onFreezeTeammate],
  );

  return (
    <UIModal onClose={onClose}>
      <div className={classNames('profile__modal', { mobile: isMobile })}>
        <div className="profile__modal-title">Select a date to freeze team members</div>
        <Calendar
          onDateSelect={handleSubmit}
          onCancel={onClose}
          submitButtonTitle="Freeze"
          wrapperClassName="freezeTeammateModal__calendar-wrapper"
          fromMonth={new Date()}
          toMonth={toMonth}
          disabledDays={[{ from: new Date(0), to: new Date() }, { after: toMonth }]}
        />
      </div>
    </UIModal>
  );
};

export default FreezeTeammateModal;
